import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Modal from '../Modal/Modal';
import VehicleSelector from './components/VehicleSelector';
import { setListingCompatibilityList } from '../../thunks/Compatibility/getListingCompatibilityList';
import { getCarIds } from '../../utils/compatibilityHelper';

const CompatibilityModal = ({ visible, toggleVisible }) => {
  const dispatch = useDispatch();
  const { vehicleCompatibilityList } = useSelector((state) => ({
    vehicleCompatibilityList: state?.vehicleCompatibilityList.data
  }), shallowEqual);

  const onSave = () => {
    dispatch(setListingCompatibilityList(vehicleCompatibilityList));
    toggleVisible();
  };

  return (
    <Modal
      toggleVisible={toggleVisible}
      onSave={onSave}
      title="Compatibility"
      saveText="Save"
      visible={visible}
      hideCloseBtn
      canSave={!getCarIds(vehicleCompatibilityList).length}
    >
      <div className="min-w-[700px]">
        <VehicleSelector />
      </div>
    </Modal>
  );
};

CompatibilityModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func
};

CompatibilityModal.defaultProps = {
  visible: false,
  toggleVisible: () => {}
};

export default CompatibilityModal;
